const STORAGE_KEY = "hicya:backend-overrides";

export interface BackendOverrides {
  [serviceKey: string]: string;
}

export function getBackendOverride(serviceKey: string): string | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const overrides = JSON.parse(raw) as BackendOverrides;
    return overrides[serviceKey] ?? null;
  } catch {
    return null;
  }
}

export function setBackendOverrides(overrides: BackendOverrides): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(overrides));
  } catch {
    // localStorage unavailable (private browsing, quota exceeded)
  }
}

export function hasBackendOverrides(): boolean {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return false;
    const overrides = JSON.parse(raw) as BackendOverrides;
    return Object.keys(overrides).length > 0;
  } catch {
    return false;
  }
}

export function clearBackendOverrides(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // localStorage unavailable
  }
}

export function getBackendUrl(serviceKey: string, defaultUrl: string): string {
  return getBackendOverride(serviceKey) ?? defaultUrl;
}
